import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 9l6 6l6 -6","key":"svg-0"}]]

const IconChevronDown = createReactComponent('outline', 'chevron-down', 'ChevronDown', __iconNode);

export default IconChevronDown;